import enLang from './entries/en_US';
import amLang from './entries/am_ET';
const AppLocale = {
    en: enLang,
    am: amLang,
};

export default AppLocale;
